import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";
import { TenantApiService } from "../api/tenant.api.service";
import { TenantEffects } from "./state/tenant/effects/tenant.effects";
import * as fromTenant from "./state/tenant/reducers";
import { TenantService } from "./services/tenant.service";

export function provideTenantApi() {
    return [TenantApiService];
}

export function provideTenantStore() {
    return [
        provideState(fromTenant.featureKey, fromTenant.reducers),
        provideEffects([TenantEffects]),
        TenantService,
    ];
}
